import SVG, {IconProps} from './svg';

const IconExpandMore = (props: IconProps) => (
	<SVG alt="Arrow down" {...props}>
		<path d="m7.4 15.375-1.4-1.4 6-6 6 6-1.4 1.4-4.6-4.6Z" />
	</SVG>
);

export default IconExpandMore;
